module.exports = __webpack_public_path__ + "static/logos/mountain-forecast__logo-8d464a202239fc5f78f9fc7beeee559f.svg";